import { System } from 'common/systems/domain/resources/system.resource';
import { SystemsState } from 'common/systems/domain/entities/systems-state';

/**
 * Pure selectors over `SystemsState`. Framework-agnostic: no Angular,
 * RxJS, ngx-jsonapi services, nor `common/systems/presentation` or
 * `common/systems/application` dependency (see spec.md of
 * `systems-capability`, Requirement "Pure `systems` selectors").
 */

export function selectAll(state: SystemsState): ReadonlyArray<System> {
    return state.ids.map((id: string): System => state.entities[id]);
}

export function selectById(state: SystemsState, id: string): System | undefined {
    return state.entities[id];
}

export interface SystemPair {
    readonly send: System | undefined;
    readonly receive: System | undefined;
}

export function selectBySystemPair(
    state: SystemsState,
    sendId: string,
    receiveId: string,
): SystemPair {
    return {
        send: selectById(state, sendId),
        receive: selectById(state, receiveId),
    };
}
